const HOME_BANNER_TYPE = 'home-banner';
const TOAST_BANNER_TYPE = 'toast-banner';
const COMMUNICATION_BANNER_TYPES = new Set([HOME_BANNER_TYPE, TOAST_BANNER_TYPE]);
const DEFAULT_SOLID_BACKGROUND = 'var(--neutral-bg-tertiary)';

/**
 * @param {unknown} raw
 * @returns {{
 *  type: string,
 *  title: string|null,
 *  logoUrl: string|null,
 *  backgroundUrl: string|null,
 *  backgroundColor: string|null,
 *  ctaText: string|null,
 *  ctaLink: string|null
 * }|null}
 */
export function mapHomeBannerPayload(raw) {
  if (!raw || typeof raw !== 'object' || !COMMUNICATION_BANNER_TYPES.has(raw.type)) {
    return null;
  }
  const title = typeof raw.title === 'string' && raw.title.trim() ? raw.title.trim() : null;
  const logoUrl = typeof raw.logoUrl === 'string' && raw.logoUrl.trim() ? raw.logoUrl.trim() : null;
  const backgroundUrlRaw = raw.backgroundUrl ?? raw.backgroundURL;
  const backgroundUrlTrim = typeof backgroundUrlRaw === 'string' && backgroundUrlRaw.trim()
    ? backgroundUrlRaw.trim()
    : null;
  const backgroundColorRaw = typeof raw.backgroundColor === 'string' && raw.backgroundColor.trim()
    ? raw.backgroundColor.trim()
    : null;
  const hasBgUrl = Boolean(backgroundUrlTrim);
  const hasExplicitBgColor = Boolean(backgroundColorRaw);
  const backgroundUrl = hasBgUrl ? backgroundUrlTrim : null;
  let backgroundColor = null;
  if (!hasBgUrl) {
    backgroundColor = hasExplicitBgColor ? backgroundColorRaw : DEFAULT_SOLID_BACKGROUND;
  }
  const ctaText = typeof raw?.cta?.text === 'string' && raw.cta.text.trim() ? raw.cta.text.trim() : null;
  const ctaLink = typeof raw?.cta?.link === 'string' && raw.cta.link.trim() ? raw.cta.link.trim() : null;

  return {
    type: raw.type,
    title,
    logoUrl,
    backgroundUrl,
    backgroundColor,
    ctaText,
    ctaLink,
  };
}
